// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5405":"21489d65","6452":"0148f630","6850":"97e45808","6942":"11a67a2f"}[chunkId] + ".chunk.css";
};